import { iLedgerTransaction } from "@sdk/ledger-transactions/ledger-transactions-models";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectLedgerTransactionQueryMap,
  selectEntityMap: selectLedgerTransactionsMap,
  selectQueryMapAll: selectLedgerTransactionsMapAll,
  selectQueryAllList: selectLedgerTransactionsAllList,
  selectAllEntities: selectAllLedgerTransactions,
  selectAllEntitiesQuery: selectAllLedgerTransactionsQuery,
  selectEntityById: selectLedgerTransactionById,
  selectEntityQuery: selectLedgerTransactionQuery,
  selectEntityQueryList: selectLedgerTransactionQueryList,
} = CreateSelectorForEntities<iStore, iLedgerTransaction>({
  sliceName: "ledgerTransactions",
});

